import { ActionTypes } from "../../../constants/ActionConstants";

// open media form modal
export const openCreateMediaFormModal = () => ({
  type: ActionTypes.CreateMediaFormModal.OPEN_MEDIA_CREATE_MODAL,
});
